import { ActionType, getType } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { EntityMapState } from '../../types/state/entities/EntityMapState';
import { Company } from '../../types/amr-pipeline/models/Company';
import { collateralManagersActions } from '../../actions/entities/collateralManagers.action';
import { apiUtils } from '../../utils';

export const collateralManagersDefaultState: EntityMapState<string, Company> = {
    items: {},
    requestState: RequestState.none,
};

export type CollateralManagersActionTypes = ActionType<
    | typeof collateralManagersActions.requestCollateralManagers
    | typeof collateralManagersActions.responseCollateralManagers
>;

export function collateralManagersReducer(
    state = collateralManagersDefaultState,
    action: CollateralManagersActionTypes,
): EntityMapState<string, Company> {
    switch (action.type) {
        case getType(collateralManagersActions.requestCollateralManagers):
            return {
                ...state,
                requestState: action.payload.requestState,
            };
        case getType(collateralManagersActions.responseCollateralManagers):
            return {
                requestState: action.payload.requestState,
                items: apiUtils.normalize(action.payload.collateralManagers, c => c.referenceName, c => c),
            };
        default:
            return state;
    }
}
